<template>
<div class="time-question">
  <div class="time-content">
    <img v-if="node.question.image !== null" :src="node.question.image" class="question-image" />
    <p v-if="node.prompt !== null" v-html="node.prompt"></p>
    <div v-html="node.question.instructions"></div>
    <v-time-picker class="time-picker" v-model="time"></v-time-picker>
  </div>
  <div class="buttons">
    <v-btn
      class="submit-button"
      :disabled="!isValidSelection()"
      color="primary"
      @click="onAnswerQuestion">
      {{ submitButton }}
    </v-btn>
    <v-btn
      v-if="node.skippable"
      class="submit-button"
      color="secondary"
      @click="onSkipQuestion">
      {{ skipButton }}
    </v-btn>
  </div>
</div>
</template>

<script>
export default {
  name: 'TimeQuestion',
  data() {
    return {
      time: this.node.question.default_time,
    };
  },
  methods: {
    isValidSelection() {
      return this.time !== null;
    },
    onAnswerQuestion() {
      this.$emit('answer', { node: this.node, text: this.time });
      this.time = null;
    },
    onSkipQuestion() {
      this.$emit('skip');
      this.time = null;
    },
  },
  props: {
    node: Object,
    submitButton: String,
    skipButton: String,
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.time-question {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .time-content {
    display: flex;
    flex-direction: column;

    .question-image {
      display: block;
      max-width: 340px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 2rem;
    }

    .time-picker {
      align-self: center;
      margin-bottom: 2rem;
    }
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

@media (min-width: $breakpoint-tablet) {
  .time-question {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
